import { Fragment } from 'react';

import styles from './styles.module.scss';
import { IErpObjectChecklist } from '../../../ApiPackage/SearchModule/interfaces/IErpObjectChecklist';

interface IKnmErpObjectChecklistProps {
  chlistHeaders?: Array<IErpObjectChecklist>;
}

export const KnmErpObjectChecklist = ({ chlistHeaders }: IKnmErpObjectChecklistProps) => (
  <>
    {chlistHeaders && chlistHeaders.length > 0 && (
      <>
        <span className={styles.SectionTitle}>Проверочные листы</span>
        {chlistHeaders.map((chlistHeader, chlistHeaderIndex) => (
          <Fragment key={chlistHeaderIndex}>
            <span className={styles.SectionTitle}>{`Проверочный лист №${chlistHeaderIndex + 1}`}</span>
            {chlistHeader.name && (
              <div className={styles.Row}>
                <div className={styles.ColText}>Наименование проверочного листа</div>
                <div className={styles.ColValue}>{chlistHeader.name}</div>
              </div>
            )}
            {chlistHeader.approval && (
              <div className={styles.Row}>
                <div className={styles.ColText}>Сведения об утверждении проверочного листа</div>
                <div className={styles.ColValue}>{chlistHeader.approval}</div>
              </div>
            )}
            {chlistHeader.frguOrgName && (
              <div className={styles.Row}>
                <div className={styles.ColText}>
                  Наименование органа контроля (надзора) из Федерального реестра государственных и муниципальных услуг
                  (ФРГУ)
                </div>
                <div className={styles.ColValue}>{chlistHeader.frguOrgName}</div>
              </div>
            )}
            {chlistHeader.chlist && chlistHeader.chlist.length > 0 && (
              <>
                <span className={styles.SectionTitle}>Список вопросов проверочного листа</span>
                {chlistHeader.chlist
                  .sort((a, b) => (a.posId > b.posId ? 1 : 0))
                  .map((chlist, chlistIndex) => (
                    <Fragment key={chlistIndex}>
                      <span className={styles.SectionTitle}>{`Контрольный вопрос №${chlistIndex + 1}`}</span>
                      {chlist.posId && (
                        <div className={styles.Row}>
                          <div className={styles.ColText}>Идентификатор вопроса проверочного листа</div>
                          <div className={styles.ColValue}>{chlist.posId}</div>
                        </div>
                      )}
                      {chlist.question && (
                        <div className={styles.Row}>
                          <div className={styles.ColText}>Вопрос проверочного листа</div>
                          <div className={styles.ColValue}>{chlist.question}</div>
                        </div>
                      )}
                      {chlist.answerTypeName && (
                        <div className={styles.Row}>
                          <div className={styles.ColText}>Ответ проверочного листа</div>
                          <div className={styles.ColValue}>{chlist.answerTypeName}</div>
                        </div>
                      )}
                      {chlist.answerText && (
                        <div className={styles.Row}>
                          <div className={styles.ColText}>Ответ (иное) проверочного листа</div>
                          <div className={styles.ColValue}>{chlist.answerText}</div>
                        </div>
                      )}
                      {chlist.props && (
                        <div className={styles.Row}>
                          <div className={styles.ColText}>Реквизиты НПА устанавливающего обязательные требования</div>
                          <div className={styles.ColValue}>{chlist.props}</div>
                        </div>
                      )}
                    </Fragment>
                  ))}
              </>
            )}
          </Fragment>
        ))}
      </>
    )}
  </>
);
